/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Searchbusinessesplaceholder2Inputs */

const en_searchbusinessesplaceholder2 = /** @type {(inputs: Searchbusinessesplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search businesses...`)
};

const de_searchbusinessesplaceholder2 = /** @type {(inputs: Searchbusinessesplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmen suchen…`)
};

/**
* | output |
* | --- |
* | "Search businesses..." |
*
* @param {Searchbusinessesplaceholder2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const searchbusinessesplaceholder2 = /** @type {((inputs?: Searchbusinessesplaceholder2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Searchbusinessesplaceholder2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_searchbusinessesplaceholder2(inputs)
	return de_searchbusinessesplaceholder2(inputs)
});
export { searchbusinessesplaceholder2 as "searchBusinessesPlaceholder" }